import dayjs from "dayjs";

export const TODAY = dayjs().format("YYYY-MM-DD");

export const DAYS_OF_WEEK = ["일", "월", "화", "수", "목", "금", "토"];
